import { combineReducers } from "redux";
import { commonReducer } from "./common-reducer";
import { queryParametersReducer } from "./query-parameters-reducer";
import { submissionReducer } from "./submission-reducer";
import { verificationConfigurationReducer } from "./verification-configuration-reducer";
import { verificationStepConfigReducer } from "./verification-step-config-reducer";
import { errorReducer } from "./error-reducer";
import { languageReducer } from "./language-reducer";
import { sdkReducer } from "./sdk-reducer";
import { validationResultsReducer } from "./validation-results-reducer";
import { tmxReducer } from "./tmx-reducer";

export const rootReducer = combineReducers({
    common: commonReducer,
    error: errorReducer,
    language: languageReducer,
    queryParameters: queryParametersReducer,
    sdk: sdkReducer,
    submission: submissionReducer,
    tmx: tmxReducer,
    validationResults: validationResultsReducer,
    verificationConfiguration: verificationConfigurationReducer,
    verificationStepConfig: verificationStepConfigReducer,
});